export const VISIBILITY_FILTERS = {
    ALL: "all",
    COMPLETED: "completed",
    INCOMPLETE: "incomplete"
  };
export const SORT_COLUMNS = {
  DATE:"date",
  VALUE:"value",
  RECIPIENT:"recipient",
  PURPOSE:"purpose",
  CATEGORY:"category"
  };




